var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-110.000000, -282.000000)",
    stroke: "#333333"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(111.000000, 283.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 7,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,24 C20,18.4771525 15.5228475,14 10,14 C4.4771525,14 0,18.4771525 0,24"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon-user.977f308098d17a8fd432255a87b8e79e.svg";
export { ForwardRef as ReactComponent };